import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import axios from "axios"

export default class ImageLiminaires extends Component {
  constructor(props) {
    super(props);
    this.state={

    }
  }
  render() {
    let {id,url} = this.props.image
    return (
      <React.Fragment>
      <img style={imageStyle} src={url} alt=""/>

      </React.Fragment>
    );
  }
}
const imageStyle = {
  display: "inline-block",
  width: "30vw",
  marginLeft: "2vw"
}
